// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"1854d71acf4242ee","6831":"a200803226c22a69","8503":"17cc926b76b01e49","9683":"e08a6fe1ec81ac41"}[chunkId] + ".js";
};